<template>
  <div class="bbp-time-history-item">
    <div class="bbp-time-history-item-header">
      <div>{{date}}</div>
      <div>{{totalTimeDay}}</div>
    </div>
    <template v-for="item in dayItem">
      <BBPTimeHistoryItemPanel
        :key="item._id"
        :item="item"
        :isShowBody.sync="isShowBody"
        :position.sync="positionPopup"
        :isShowModal.sync="isShowModalPopup"
        :currentItem.sync="currentItemDef"
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import BBPTimeHistoryItemPanel
  from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryItem/BBPTimeHistoryItemPanel'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'

export default {
  name: 'BBPTimeHistoryItem',
  components: {
    BBPTimeHistoryItemPanel
  },
  mixins: [convertSecondsToTime],
  props: {
    name: {
      type: String,
      default: ''
    },
    dayItem: {
      type: Array,
      default: () => ([])
    },
    position: {
      type: Object,
      default: () => ({})
    },
    currentItem: {
      type: Object,
      default: () => ({})
    },
    isShowModal: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isShowBody: []
  }),
  computed: {
    positionPopup: {
      get () {
        return this.position
      },
      set (data) {
        this.$emit('update:position', data)
      }
    },
    isShowModalPopup: {
      get () {
        return this.isShowModal
      },
      set (data) {
        this.$emit('update:isShowModal', data)
      }
    },
    currentItemDef: {
      get () {
        return this.currentItem
      },
      set (data) {
        this.$emit('update:currentItem', data)
      }
    },
    date () {
      const date = moment(this.name, 'D-M-YYYY').format('MMMM DD, YYYY')
      const currentDate = moment(new Date()).format('D-M-YYYY')
      if (currentDate === this.name) {
        return 'Today'
      }
      return date
    },
    totalTimeDay () {
      const secondsTotal = this.dayItem.reduce((total, current) => total + (current.totalTime || 0), 0)
      const sec = Math.floor(secondsTotal / 1000)
      return this.convertSecondsToTime(sec, true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .hide {
    display: none !important;
  }

  .bbp-time-history-item {
    padding: 0 0 27px 0;

    & + & {
      padding: 27px 0 27px 0;
      border-top: 2px solid $color-alabaster;
    }
  }

  .bbp-time-history-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 24px 0;
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryItem/BBPTimeHistoryItem.vue